// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App'
import router from './router'
import http from './assets/js/http'
Vue.prototype.http=http;
import URL from './assets/js/url'
Vue.prototype.URL=URL;
//全局组件
import components from './components/components'
//过滤器
import vueFilter from './assets/js/filters'
for (let key in vueFilter){
    Vue.filter(key,vueFilter[key])
}
Vue.use(components);
Vue.use(ElementUI);


//设置标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title+' - iTrust'
    }
    next()
})


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js